import styled from 'styled-components';

export const MissionContainer = styled.div`
  width: 100%;
  height: 10vh;
`;
